import React from "react";
import { CheckCircle2, XCircle, AlertCircle, Loader2 } from "lucide-react";

/**
 * ReadinessCard — one dimension of the readiness dashboard.
 *
 * state: "ready" | "missing" | "partial" | "loading"
 * label: short human-readable dimension title
 * detail: optional descriptive text (e.g. "3 of 5 components mapped")
 */
export function ReadinessCard({ label, state, detail, action, testid }) {
  const icon =
    state === "ready"   ? <CheckCircle2 className="w-5 h-5 text-emerald-400" /> :
    state === "missing" ? <XCircle       className="w-5 h-5 text-red-400" /> :
    state === "partial" ? <AlertCircle   className="w-5 h-5 text-amber-400" /> :
                          <Loader2       className="w-5 h-5 text-slate-400 animate-spin" />;

  const ring =
    state === "ready"   ? "border-emerald-800/50 bg-emerald-950/20" :
    state === "missing" ? "border-red-800/50 bg-red-950/20" :
    state === "partial" ? "border-amber-800/50 bg-amber-950/20" :
                          "border-slate-800 bg-slate-900/40";

  return (
    <div
      data-testid={testid ?? `readiness-card-${label?.toLowerCase().replace(/\s+/g, "-")}`}
      className={`rounded-xl border p-4 flex flex-col gap-2 ${ring}`}
    >
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-sm font-semibold text-slate-200">{label}</span>
      </div>
      {detail && (
        <p className="text-xs text-slate-400 leading-relaxed">{detail}</p>
      )}
      {action && (
        <div className="mt-1">{action}</div>
      )}
    </div>
  );
}
